import { Company } from '@lx/shared/types';

/**
 * Configuration for brands using the new design system tokens package
 * (@klg/common-design-system-tokens).
 *
 * Brands listed here will have their design tokens loaded separately from
 * their theme CSS, allowing for better separation of concerns and caching.
 *
 * When adding a new brand to this list:
 * 1. Ensure the design tokens file exists: node_modules/@klg/common-design-system-tokens/dist/{brand}.css
 * 2. Update project.json to bundle the tokens (for apps using CompanyThemeLoaderService)
 * 3. No additional code changes needed - this constant is used by both index-transform.ts and CompanyThemeLoaderService
 *
 * Legacy brands (kaplan, esl, alpadia) use local colors.css files embedded in their theme CSS.
 */
export const BRANDS_WITH_DESIGN_TOKENS: readonly Company[] = ['positively-languages', 'kaplan'] as const;

/**
 * Type guard to check if a company uses design system tokens
 * @param company - The company to check
 * @returns true if the company uses design system tokens from the npm package
 */
export function usesDesignTokens(company: Company): boolean {
  return BRANDS_WITH_DESIGN_TOKENS.includes(company);
}
